// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserFieldsFragment = { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, avatar_url?: string | null, created_at: number, is_admin?: boolean | null, is_developer?: boolean | null, bio: string, years_of_experience?: number | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null };

export type PublicUserFieldsFragment = { __typename?: 'PublicUser', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null };

export type CurrentUserFieldsFragment = { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, avatar_url?: string | null, created_at: number, is_admin?: boolean | null, is_developer?: boolean | null, bio: string, years_of_experience?: number | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null };

export type GetUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, avatar_url?: string | null, created_at: number, is_admin?: boolean | null, is_developer?: boolean | null, bio: string, years_of_experience?: number | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null } };

export type UserMutationVariables = Types.Exact<{
  data: Types.UpdateUserInput;
}>;


export type UserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, avatar_url?: string | null, created_at: number, is_admin?: boolean | null, is_developer?: boolean | null, bio: string, years_of_experience?: number | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null } };

export type CreateGuestUserMutationVariables = Types.Exact<{
  data: Types.CreateUserInput;
}>;


export type CreateGuestUserMutation = { __typename?: 'Mutation', createGuestUser: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, avatar_url?: string | null, created_at: number, is_admin?: boolean | null, is_developer?: boolean | null, bio: string, years_of_experience?: number | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null } };

export type SearchUsersQueryVariables = Types.Exact<{
  text: Types.Scalars['String']['input'];
  size: Types.Scalars['PositiveInt']['input'];
  page: Types.Scalars['NonNegativeInt']['input'];
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: { __typename?: 'UsersSearchResults', total: number, pages: number, results: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, avatar_url?: string | null, created_at: number, is_admin?: boolean | null, is_developer?: boolean | null, bio: string, years_of_experience?: number | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null }> } };

export type SearchOutfittersForImpersonationQueryVariables = Types.Exact<{
  text: Types.Scalars['String']['input'];
  size: Types.Scalars['PositiveInt']['input'];
  page: Types.Scalars['NonNegativeInt']['input'];
}>;


export type SearchOutfittersForImpersonationQuery = { __typename?: 'Query', searchOutfittersForImpersonation: { __typename?: 'OutfittersForImpersonationSearchResults', total: number, pages: number, results: Array<{ __typename?: 'OutfitterForImpersonationSearchResult', outfitter: { __typename?: 'Outfitter', id: string, name: string, avatar?: { __typename?: 'Media', url: string } | null }, members: Array<{ __typename?: 'ImpersonationMember', role: Types.TeamMemberRole, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, avatar_url?: string | null, created_at: number, is_admin?: boolean | null, is_developer?: boolean | null, bio: string, years_of_experience?: number | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null } }>, auto_select_member?: { __typename?: 'ImpersonationMember', role: Types.TeamMemberRole, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, avatar_url?: string | null, created_at: number, is_admin?: boolean | null, is_developer?: boolean | null, bio: string, years_of_experience?: number | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null } } | null }> } };

export type UsersForMentionsQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
}>;


export type UsersForMentionsQuery = { __typename?: 'Query', usersForMentions: Array<{ __typename?: 'PublicUser', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }> };

export const PublicUserFieldsFragmentDoc = gql`
    fragment PublicUserFields on PublicUser {
  id
  first_name
  last_name
  avatar_url
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  first_name
  last_name
  email
  phone
  avatar_url
  created_at
  is_admin
  is_developer
  impersonation_details {
    is_impersonated
  }
  bio
  years_of_experience
}
    `;
export const CurrentUserFieldsFragmentDoc = gql`
    fragment CurrentUserFields on User {
  ...UserFields
}
    ${UserFieldsFragmentDoc}`;
export const GetUserDocument = gql`
    query getUser {
  user {
    ...CurrentUserFields
  }
}
    ${CurrentUserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const UserDocument = gql`
    mutation user($data: UpdateUserInput!) {
  updateUser(data: $data) {
    ...CurrentUserFields
  }
}
    ${CurrentUserFieldsFragmentDoc}`;
export type UserMutationFn = Apollo.MutationFunction<UserMutation, UserMutationVariables>;

/**
 * __useUserMutation__
 *
 * To run a mutation, you first call `useUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userMutation, { data, loading, error }] = useUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUserMutation(baseOptions?: Apollo.MutationHookOptions<UserMutation, UserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserMutation, UserMutationVariables>(UserDocument, options);
      }
export type UserMutationHookResult = ReturnType<typeof useUserMutation>;
export type UserMutationResult = Apollo.MutationResult<UserMutation>;
export type UserMutationOptions = Apollo.BaseMutationOptions<UserMutation, UserMutationVariables>;
export const CreateGuestUserDocument = gql`
    mutation createGuestUser($data: CreateUserInput!) {
  createGuestUser(data: $data) {
    ...CurrentUserFields
  }
}
    ${CurrentUserFieldsFragmentDoc}`;
export type CreateGuestUserMutationFn = Apollo.MutationFunction<CreateGuestUserMutation, CreateGuestUserMutationVariables>;

/**
 * __useCreateGuestUserMutation__
 *
 * To run a mutation, you first call `useCreateGuestUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGuestUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGuestUserMutation, { data, loading, error }] = useCreateGuestUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGuestUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateGuestUserMutation, CreateGuestUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGuestUserMutation, CreateGuestUserMutationVariables>(CreateGuestUserDocument, options);
      }
export type CreateGuestUserMutationHookResult = ReturnType<typeof useCreateGuestUserMutation>;
export type CreateGuestUserMutationResult = Apollo.MutationResult<CreateGuestUserMutation>;
export type CreateGuestUserMutationOptions = Apollo.BaseMutationOptions<CreateGuestUserMutation, CreateGuestUserMutationVariables>;
export const SearchUsersDocument = gql`
    query searchUsers($text: String!, $size: PositiveInt!, $page: NonNegativeInt!) {
  searchUsers(text: $text, size: $size, page: $page) {
    results {
      ...UserFields
    }
    total
    pages
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      text: // value for 'text'
 *      size: // value for 'size'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const SearchOutfittersForImpersonationDocument = gql`
    query searchOutfittersForImpersonation($text: String!, $size: PositiveInt!, $page: NonNegativeInt!) {
  searchOutfittersForImpersonation(text: $text, size: $size, page: $page) {
    results {
      outfitter {
        id
        name
        avatar {
          url
        }
      }
      members {
        role
        user {
          ...UserFields
        }
      }
      auto_select_member {
        role
        user {
          ...UserFields
        }
      }
    }
    total
    pages
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useSearchOutfittersForImpersonationQuery__
 *
 * To run a query within a React component, call `useSearchOutfittersForImpersonationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOutfittersForImpersonationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOutfittersForImpersonationQuery({
 *   variables: {
 *      text: // value for 'text'
 *      size: // value for 'size'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSearchOutfittersForImpersonationQuery(baseOptions: Apollo.QueryHookOptions<SearchOutfittersForImpersonationQuery, SearchOutfittersForImpersonationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOutfittersForImpersonationQuery, SearchOutfittersForImpersonationQueryVariables>(SearchOutfittersForImpersonationDocument, options);
      }
export function useSearchOutfittersForImpersonationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOutfittersForImpersonationQuery, SearchOutfittersForImpersonationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOutfittersForImpersonationQuery, SearchOutfittersForImpersonationQueryVariables>(SearchOutfittersForImpersonationDocument, options);
        }
export type SearchOutfittersForImpersonationQueryHookResult = ReturnType<typeof useSearchOutfittersForImpersonationQuery>;
export type SearchOutfittersForImpersonationLazyQueryHookResult = ReturnType<typeof useSearchOutfittersForImpersonationLazyQuery>;
export type SearchOutfittersForImpersonationQueryResult = Apollo.QueryResult<SearchOutfittersForImpersonationQuery, SearchOutfittersForImpersonationQueryVariables>;
export const UsersForMentionsDocument = gql`
    query usersForMentions($outfitterId: ID!) {
  usersForMentions(outfitterId: $outfitterId) {
    ...PublicUserFields
  }
}
    ${PublicUserFieldsFragmentDoc}`;

/**
 * __useUsersForMentionsQuery__
 *
 * To run a query within a React component, call `useUsersForMentionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersForMentionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersForMentionsQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *   },
 * });
 */
export function useUsersForMentionsQuery(baseOptions: Apollo.QueryHookOptions<UsersForMentionsQuery, UsersForMentionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersForMentionsQuery, UsersForMentionsQueryVariables>(UsersForMentionsDocument, options);
      }
export function useUsersForMentionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersForMentionsQuery, UsersForMentionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersForMentionsQuery, UsersForMentionsQueryVariables>(UsersForMentionsDocument, options);
        }
export type UsersForMentionsQueryHookResult = ReturnType<typeof useUsersForMentionsQuery>;
export type UsersForMentionsLazyQueryHookResult = ReturnType<typeof useUsersForMentionsLazyQuery>;
export type UsersForMentionsQueryResult = Apollo.QueryResult<UsersForMentionsQuery, UsersForMentionsQueryVariables>;